<template>
    <v-autocomplete hide-no-data :items="items" :loading="loading" :search-input.sync="search"
      hide-details no-filter item-text="name" clearable item-value="id" label="Search" solo>
      <template v-slot:item="{ item }">
        <template v-if="typeof item !== 'object'">
          <v-list-item :disabled="true">
            <v-list-item-content>
              <v-list-item-subtitle v-text="item"></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>
        <template v-else>
          <v-list-item-avatar v-if="item.forProfile === 'Customer'" color="green" class="text-h5 font-weight-light">
            <v-icon>mdi-account-outline</v-icon>
          </v-list-item-avatar>
          <v-list-item-avatar v-else-if="item.forProfile === 'Donor'" color="red" class="text-h5 font-weight-light white--text">
            <v-icon color="white">mdi-hand-coin-outline</v-icon>
          </v-list-item-avatar>
          <v-list-item-avatar v-else-if="item.forProfile === 'Student'" color="indigo" class="text-h5 font-weight-light white--text">
            <v-icon color="white">mdi-account-school-outline</v-icon>
          </v-list-item-avatar>
          <v-list-item-avatar v-else color="#00BFA5" class="text-h5 font-weight-light white--text">
            <v-icon color="white">mdi-filter-outline</v-icon>
          </v-list-item-avatar>
          <v-list-item-content @click="viewProfile(item)" @keyup.enter="viewProfile(item)">
            <v-list-item-title v-text="item.name"></v-list-item-title>
            <v-list-item-subtitle v-text="item.phoneNumber"></v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </template>
    </v-autocomplete>
</template>

<script>
import customerService from "@/modules/Customer/service.js";
import donorService from "@/modules/Donors/service.js";
import studentService from "@/modules/Student/service.js";
import applicationService from "@/modules/Application/service.js";

export default {
  data(){
    return{
      search: null,
      items: [],
      loading: false,
    }
  },
  watch: {
    search(val) {
      if(!val){
        this.items = []
        return true
      }
      if(val.length < 3){
        return true
      }
      this.items = []
      this.getCustomer(val)
      this.getDonor(val)
      this.getStudent(val)
      this.getApplication(val)
    }
  },
  methods: {
    viewProfile(val) {
      this.$emit('searched')
      if(val.forProfile === "Customer"){
        this.$router.push({ path: `/parents/${val.id}/profile` });
        this.$events.emit("customerProfileEvent");
      }else if(val.forProfile === "Donor"){
        this.$router.push({ path: `/donors/${val.id}/profile` });
        this.$events.emit("customerProfileEvent");
      }else if(val.forProfile === "Student"){
        this.$router.push({ name: "customer-profile", params: { tab: 1, id: val.Customer.id} });
        this.$events.emit("customerProfileEvent");
      }else{
        this.$router.push({ path: `/applications/${val.Lead.id}/profile` });
        this.$events.emit("applicationProfileEvent");
      }
    },
    getCustomer(val){
      this.loading = true
      customerService.getAll({search:val})
      .then(res => {
        if(res.data.length){
          this.items.push('Parent')
          res.data.map(row => {
            row.forProfile = "Customer"
            this.items.push(row)
          })
        }
      })
      .catch(err => {
        console.log("ERROR", err)
      })
      .finally(() => (this.loading = false))
    },
    getDonor(val){
      this.loading = true
      donorService.getAll({search:val})
      .then(res => {
        if(res.data.length){
          this.items.push('Donor')
          res.data.map(row => {
            row.forProfile = "Donor"
            this.items.push(row)
          })
        }
      })
      .catch(err => {
        console.log("ERROR", err)
      })
      .finally(() => (this.loading = false))
    },
    getStudent(val){
      this.loading = true
      studentService.getAll({search:val})
      .then(res => {
        if(res.data.length){
          this.items.push('Student')
          res.data.map(row => {
            row.forProfile = "Student"
            row.name = row.fullName
            this.items.push(row)
          })
        }
      })
      .catch(err => {
        console.log("ERROR", err)
      })
      .finally(() => (this.loading = false))
    },
    getApplication(val){
      this.loading = true
      applicationService.getAllStudent({search:val})
      .then(res => {
        if(res.data.length){
          this.items.push('Application')
          res.data.map(row => {
            row.forProfile = "Application"
            row.name = `#${row.localId} ${row.fullName}`
            this.items.push(row)
          })
        }
      })
      .catch(err => {
        console.log("ERROR", err)
      })
      .finally(() => (this.loading = false))
    }
  }
}
</script>